import axios from "axios";
import { authHeader } from "./utils";
import { GET_REPEATER, LIST_REPEATER } from "./types";

export const getRepeater = (devEUI) => async (dispatch) => {
  const res = await axios.get(`/api/repeaters/${devEUI}`, {
    headers: authHeader(),
  });
  console.log("res", res.data);
  dispatch({ type: GET_REPEATER, payload: res.data });
};

export const fetchRepeaters =
  ({ page, limit, all }) =>
  async (dispatch) => {
    const res = await axios.get("/api/repeaters", {
      headers: authHeader(),
      params: { page, limit, all },
    });
    console.log("res", res.data);
    dispatch({ type: LIST_REPEATER, payload: res.data });
  };

export const submitRepeater =
  ({ repeater }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.post("/api/repeaters", repeater, {
          headers: authHeader(),
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });

export const updateRepeater =
  ({ repeater, devEUI }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.put(`/api/repeaters/${devEUI}`, repeater, {
          headers: authHeader(),
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });

export const deleteRepeater =
  ({ devEUI }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        await axios.delete(`/api/repeaters/${devEUI}`, {
          headers: authHeader(),
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });

export const activateRepeater =
  ({ repeater }) =>
  async () => {
    try {
      console.log("repeater", repeater);
      const res = await axios.post(
        `/api/repeaters/${repeater.devEUI}/activate`,
        repeater,
        {
          headers: authHeader(),
        }
      );
    } catch (error) {
      console.log(error);
    }
  };
